export default {
  metadata: {
    version: '1.0.0',
    id: 'side-panel-item-1.0.0',
    name: 'JDSSidePanelItem'
  },
  hierarchy: {
    container: [
      {
        'inner-container': [
          {
            'prefix-jds-icon-container': ['prefix-jds-icon']
          },
          'title-jds-text'
        ]
      },
      'suffix-jds_action_button',
      'heading-jds-text',
      'jds_divider'
    ]
  },
  base: {
    jds_divider: {
      hidden: true,
      pad: 'none',
      orientation: 'horizontal'
    },
    container: {
      'flex-direction': '{s_2}',
      'justify-content': '{s_3}',
      'align-items': '{s_4}',
      width: '{s_5}'
    },
    'inner-container': {
      'flex-direction': '{s_6}',
      'justify-content': '{s_7}',
      'align-items': '{s_8}',
      gap: '{s_9}',
      'padding-top': '{s_10}',
      'padding-bottom': '{s_11}',
      flex: 1
    },
    'suffix-jds_action_button': {
      hidden: false,
      icon: 'ic_next',
      size: 'medium',
      kind: 'tertiary'
    },
    'heading-jds-text': {
      'font-family': '{text_152}',
      color: '{text_20}',
      'font-size': '{text_151}',
      'line-height': '{text_153}',
      'letter-spacing': '{text_154}',
      'font-weight': '{text_155}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true,
      'padding-top': '{s_0}',
      'padding-bottom': '{s_1}'
    },
    'prefix-jds-icon': {
      size: '{icon_79}',
      color: '{icon_7}'
    },
    'prefix-jds-icon-container': {
      'background-color': '{icon_31}',
      'border-radius': '{icon_1}',
      size: '{icon_78}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}'
    },
    'title-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    showSuffix: {
      false: {
        'suffix-jds_action_button': {
          hidden: true
        }
      }
    },
    type: {
      divider: {
        container: {
          'padding-top': '0',
          'padding-bottom': '0'
        },
        'inner-container': {
          hidden: true
        },
        'suffix-jds_action_button': {
          hidden: true
        },
        jds_divider: {
          hidden: false
        }
      },
      heading: {
        container: {
          'padding-top': '0',
          'padding-bottom': '0'
        },
        'inner-container': {
          hidden: true
        },
        'suffix-jds_action_button': {
          hidden: true
        },
        'heading-jds-text': {
          hidden: false
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      type: {
        values: ['entry', 'divider', 'heading']
      },
      showSuffix: {
        values: [true, false]
      }
    },
    data: {
      'prefix-jds-icon': {
        value: {
          type: 'icon',
          name: 'prefix'
        }
      },
      'title-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      },
      'heading-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      }
    },
    events: {
      'suffix-jds_action_button': {
        onClick: 'onSuffixClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'listitem'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'title'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'suffix-jds_action_button': {
        properties: {
          ariaLabel: 'itemSuffixAriaLabel'
        }
      }
    }
  }
};
